import React, { createContext, useContext } from 'react';
import { OptionTypeEnum } from 'src/components/filter-dropdown';
import { EmptyProduct } from '../product-context';
import type { IPriceRowContext } from './price-row/types';

const initialValue: IPriceRowContext = {
  offer: {
    featured: false,
    authorizedDealer: false,
    isInternationalPrice: false,
  },
  product: EmptyProduct,
  isFeatured: false,
  showExpandButton: true,
  showUnfeaturedHideButton: false,
  setShowUnfeaturedPlaceholder: undefined,
  sorting: OptionTypeEnum.CHEAPEST_PRICE,
};
const PriceRowContext = createContext<IPriceRowContext>(initialValue);

export const usePriceRowContext = () => useContext(PriceRowContext);

export const PriceRowContextContainer: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IPriceRowContext>>
> = props => {
  return (
    <PriceRowContext.Provider value={props}>
      {props.children}
    </PriceRowContext.Provider>
  );
};
